var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.optionModel.type === 'password')?_c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.showPassword')}},[_c('el-switch',{model:{value:(_vm.optionModel.showPassword),callback:function ($$v) {_vm.$set(_vm.optionModel, "showPassword", $$v)},expression:"optionModel.showPassword"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }